import Repository from './Repository'

const resource = 'kladr'

export default {
  get(nameLib, config = {}) {
    config.params.withParent = 1

    return Repository.get(resource + nameLib, config)
  },
  post(nameLib, config = {}) {
    return Repository.post(resource + nameLib, config)
  },
  request(config) {
    config.params.withParent = 1

    return Repository.request(config)
  },
}
